import React from "react"
import { Field } from "../../field"
import { FieldError } from "react-hook-form"
import { CheckboxesForCompetitionMarketingFormProps } from "../../../types/cms/competition-marketing-form"

export const CheckboxesForCompetitionMarketingForm = ({
  form,
  formCheckboxes
}: CheckboxesForCompetitionMarketingFormProps) => {
  return (
    <>
      <Field
        type="checkbox"
        name="marketingPermission1"
        control={form.control}
        defaultValue={false}
        showAsterisk={true}
        label={formCheckboxes?.firstCheckbox?.firstCheckboxDescription?.description}
        error={form.formState.errors.marketingPermission1 as FieldError | undefined}
      />
      {formCheckboxes?.displaySecondCheckbox && (
        <Field
          type="checkbox"
          name="marketingPermission2"
          control={form.control}
          defaultValue={false}
          label={formCheckboxes?.secondCheckboxDescription?.description}
          error={form.formState.errors.marketingPermission2 as FieldError | undefined}
        />
      )}
    </>
  )
}